"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function BackuppoliciesGreyMultitoneOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__backuppolicies-grey-multitone-outline__clip0_14556_7429)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.99,
    cy: 8.243,
    fill: "#CCE5FF",
    rx: 4,
    ry: 4.117
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.567 11.842a.476.476 0 01-.074.26.44.44 0 01-.696.075.47.47 0 01-.1-.508.463.463 0 01.167-.21.443.443 0 01.57.056.463.463 0 01.133.327z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.12 13.624a1.705 1.705 0 01-1.08-.401 1.753 1.753 0 01-.483-.62 1.805 1.805 0 01-.169-.773c0-.352.102-.697.292-.99.19-.293.46-.521.777-.656.316-.135.664-.17 1-.101.336.068.644.238.886.487.242.25.407.567.474.913a1.83 1.83 0 01-.099 1.03 1.772 1.772 0 01-.637.799c-.285.196-.62.3-.962.3v.012zm0-2.76a.93.93 0 00-.437.108.96.96 0 00-.34.304.996.996 0 00-.121.89c.05.147.133.28.244.387a.925.925 0 001.246.056.987.987 0 00.359-.767c0-.26-.1-.508-.28-.692a.937.937 0 00-.672-.287z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.12 10.871a.384.384 0 01-.277-.117.408.408 0 01-.114-.284v-.546c0-.106.041-.208.114-.284a.384.384 0 01.552 0 .407.407 0 01.114.284v.546a.408.408 0 01-.114.284.385.385 0 01-.276.117zM8.12 14.254a.384.384 0 01-.277-.117.408.408 0 01-.114-.284v-.546c0-.106.041-.209.114-.284a.384.384 0 01.552 0 .407.407 0 01.114.284v.546a.408.408 0 01-.114.284.385.385 0 01-.276.117zM10.03 12.288H9.5a.385.385 0 01-.277-.118.408.408 0 010-.567.385.385 0 01.276-.118h.53c.104 0 .203.042.276.118a.408.408 0 010 .567.385.385 0 01-.276.118zM6.739 12.288h-.51a.384.384 0 01-.276-.118.408.408 0 010-.567.384.384 0 01.275-.118h.527c.103 0 .202.042.275.118a.408.408 0 010 .567.384.384 0 01-.276.118H6.74zM9.468 13.68a.385.385 0 01-.273-.12l-.39-.402a.409.409 0 01.02-.544.385.385 0 01.53-.021l.39.401a.407.407 0 01-.127.655.381.381 0 01-.15.031zM7.144 11.284a.38.38 0 01-.276-.116l-.39-.401a.404.404 0 01-.114-.285.411.411 0 01.116-.283.39.39 0 01.276-.117.382.382 0 01.275.119l.39.401a.407.407 0 01-.127.653.38.38 0 01-.15.03zM6.77 13.68a.382.382 0 01-.218-.067.412.412 0 01-.059-.62l.39-.4a.389.389 0 01.277-.119.38.38 0 01.277.119.407.407 0 010 .566l-.39.4a.39.39 0 01-.277.121zM9.094 11.284a.382.382 0 01-.214-.069.412.412 0 01-.06-.613l.39-.401a.384.384 0 01.636.13.412.412 0 01-.086.44l-.39.401a.384.384 0 01-.276.112z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M9.577 7.231l1.26 1.296v6.277H5.401V7.23h4.175zm.488-1.204H5.207a.965.965 0 00-.687.294c-.182.187-.286.44-.288.706v7.982c.002.265.106.518.288.705.183.187.43.293.687.294h5.828a.96.96 0 00.685-.294c.182-.187.285-.44.286-.705v-7l-1.95-2.006.009.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.895 7.231v.803c0 .32.123.625.342.851.22.226.517.353.828.353h.78v5.566H5.401V7.23H8.91h-.015zm1.185-1.204H5.207a.965.965 0 00-.687.294c-.182.187-.286.44-.288.706v7.982c.002.265.106.518.288.705.183.187.43.293.687.294h5.828a.96.96 0 00.685-.294c.182-.187.285-.44.286-.705v-7h-1.95V6.028h.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M3.335 11.774a3.31 3.31 0 01-1.966-.679A3.47 3.47 0 01.16 9.36a3.568 3.568 0 01.007-2.135 3.468 3.468 0 011.22-1.727c-.11-.57-.079-1.16.092-1.715a3.463 3.463 0 01.886-1.456c.41-.4.911-.688 1.458-.835a3.256 3.256 0 011.668-.007A4.907 4.907 0 019.001 0c1.32.01 2.583.553 3.518 1.513a5.253 5.253 0 011.475 3.62c.591.278 1.092.725 1.443 1.288.351.563.538 1.217.538 1.886.012.446-.062.89-.218 1.306a3.369 3.369 0 01-.692 1.117c-.3.322-.66.578-1.059.755a3.18 3.18 0 01-1.26.273.576.576 0 01-.413-.176.611.611 0 010-.851.576.576 0 01.414-.177c.28-.002.557-.063.814-.178a2.08 2.08 0 00.68-.493 2.15 2.15 0 00.439-.729c.097-.27.14-.559.125-.847a2.312 2.312 0 00-.429-1.355 2.205 2.205 0 00-1.13-.824.59.59 0 01-.32-.236.619.619 0 01-.105-.39V5.2a4.034 4.034 0 00-1.115-2.81 3.806 3.806 0 00-2.718-1.18c-.548 0-1.09.122-1.588.357a3.829 3.829 0 00-1.3 1.004.565.565 0 01-.651.169c-.249-.1-.514-.15-.78-.149a2.133 2.133 0 00-.836.176 2.185 2.185 0 00-.707.492c-.202.21-.362.46-.47.733a2.31 2.31 0 00-.163.863c0 .246.04.49.117.722a.623.623 0 01-.011.416.6.6 0 01-.27.31c-.43.238-.771.615-.97 1.074-.2.458-.245.972-.13 1.46.115.488.384.923.766 1.237.38.313.852.488 1.34.495.156 0 .304.064.414.177a.611.611 0 010 .851.577.577 0 01-.414.176z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__backuppolicies-grey-multitone-outline__clip0_14556_7429"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

BackuppoliciesGreyMultitoneOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
BackuppoliciesGreyMultitoneOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = BackuppoliciesGreyMultitoneOutline;
exports["default"] = _default;